import React from "react";
import SEOComponent from "../components/SEOComponent";
import HeroSection from "../components/landing/HeroSection";
import StatsSection from "../components/landing/StatsSection";
import PlansSection from "../components/landing/PlansSection";
import AboutSection from "../components/landing/AboutSection";
import NewsSection from "../components/landing/NewsSection";
import FinancialSection from "../components/landing/FinancialSection";
import DonationSection from "../components/landing/DonationSection";
import TestimonialsSection from "../components/landing/TestimonialsSection";
import CtaSection from "../components/landing/CtaSection";

function Homepage() {

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "NGO",
        "name": "Pertubuhan Kebajikan Shan De",
        "alternateName": "善德儿童福利之家",
        "url": "https://www.shandejohor.org.my/",
        "logo": "https://www.shandejohor.org.my/assets/img/sdlogo.png",
        "description": "Non-profit charity organization in Johor Bahru helping disadvantaged children since 2011. We accept children from all races regardless of religious beliefs.",
        "foundingDate": "2011-10-11",
        "address": {
            "@type": "PostalAddress",
            "addressLocality": "Johor Bahru",
            "addressRegion": "Johor",
            "addressCountry": "MY"
        },
        "areaServed": {
            "@type": "State",
            "name": "Johor"
        },
        "sameAs": [
            "https://www.facebook.com/PertubuhanKebajikanShande"
        ],
        "potentialAction": {
            "@type": "DonateAction",
            "target": "https://www.shandejohor.org.my/donate"
        }
    };

    return (
        <>
        <SEOComponent 
            title="Home"
            description="Welcome to Shan De Children's Welfare Home. We are a non-profit charity organization in Johor Bahru helping disadvantaged children since 2011. Donate, volunteer, or sponsor a child today."
            keywords="homepage, charity home, children welfare, donate now, volunteer, sponsor child"
            url="/"
            structuredData={structuredData}
        />
        <HeroSection />
        <StatsSection />
        <PlansSection />
        <AboutSection />
        <NewsSection />
        <FinancialSection />
        <DonationSection />
        <TestimonialsSection />
        <CtaSection />
        </>
    )
}
export default Homepage;